import { render, staticRenderFns } from "./Peer-attention.vue?vue&type=template&id=1823a0a0&scoped=true&"
import script from "./Peer-attention.vue?vue&type=script&lang=js&"
export * from "./Peer-attention.vue?vue&type=script&lang=js&"
import style0 from "./Peer-attention.vue?vue&type=style&index=0&id=1823a0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823a0a0",
  null
  
)

export default component.exports